import { localized } from "@msuite/ui/localization";
import { WorkspaceTag } from "@msuite/ui/tag";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { DefaultApproverNames } from "@/components/incoming-invoices";
import type { InvoiceDefaultApproverSet } from "./invoice-default-approver-sets";
import { InvoiceDefaultApproversRowActions } from "./invoice-default-approvers-row-actions";

const columnHelper = createColumnHelper<InvoiceDefaultApproverSet>();

export const columns = [
	columnHelper.accessor("name", {
		id: "name",
		header: localized("incoming_invoices.approver_set"),
		cell: (cell) =>
			cell.row.original.color ? (
				<WorkspaceTag workspace={{ name: cell.getValue(), color: cell.row.original.color }} />
			) : (
				cell.getValue()
			),
	}),
	columnHelper.accessor((row) => row.approverNames.join(", "), {
		id: "approvers",
		header: localized("incoming_invoices.default_approvers"),
		cell: (cell) => (
			<DefaultApproverNames
				workspaceId={cell.row.original.workspaceId}
				approverNames={cell.row.original.approverNames}
			/>
		),
	}),
	createRowActions(InvoiceDefaultApproversRowActions),
];
